var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m23.8 22.8-6-6.2a10 10 0 1 0-7.7 3.6 10 10 0 0 0 5.8-1.8l6 6.2a1.3 1.3 0 1 0 1.9-1.8ZM10 2.6a7.5 7.5 0 1 1-7.5 7.5 7.5 7.5 0 0 1 7.5-7.5Z","fill":"currentColor"}));
}

Search.defaultProps = {"viewBox":"0 0 24.1 25"};

module.exports = Search;

Search.default = Search;
